import { useState } from "react";
import { createRoom, type CreateRoomOut } from "../api";

export function NewRoom() {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState<CreateRoomOut | null>(null);
  const [error, setError] = useState<string | null>(null);

  const onCreate = async () => {
    setBusy(true);
    setError(null);
    try {
      const room = await createRoom();
      setResult(room);
    } catch (e) {
      setError(String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page">
      <div className="card">
        <h1>Видеовстреча — прототип</h1>
        <p className="subtitle">
          Нажмите «Создать» — получите две ссылки: одна для вас, вторая — гостю.
          Никакой регистрации, ссылка работает 12 часов.
        </p>

        {!result && (
          <button className="btn primary big" onClick={onCreate} disabled={busy}>
            {busy ? "Создаём..." : "Создать встречу"}
          </button>
        )}

        {error && <div className="error">{error}</div>}

        {result && (
          <div className="result">
            <div className="code">Код: {result.code}</div>
            <UrlRow label="Ваша ссылка (владелец)" url={result.owner_url} />
            <UrlRow label="Ссылка для гостя" url={result.guest_url} />
            <div className="row">
              <a className="btn primary" href={result.owner_url}>Открыть у себя</a>
              <button className="btn ghost" onClick={() => setResult(null)}>Ещё одна</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function UrlRow({ label, url }: { label: string; url: string }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="urlrow">
      <div className="urlrow-label">{label}</div>
      <div className="urlrow-value">
        <code>{url}</code>
        <button className="btn ghost small" onClick={copy}>
          {copied ? "Скопировано" : "Копировать"}
        </button>
      </div>
    </div>
  );
}
